<div class="page-wrapper">
    <div class="loading-overlay" *ngIf="loading">
        <div class="loader-container">
            <div class="loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>

    <div class="container-fluid main-container">
        <div class="custom-margin">
            <section class="section-card">
                <!-- Breadcrumb -->
                <div class="breadcrumb flat">
                    <!-- <a routerLink="/vendor/dashboard">Vendor</a> -->
                    <h3>RFP Details</h3>
                </div>

                <div class="form_basic mb-0">
                    <!-- Back Button -->
                    <!-- <div class="text-end">
                        <button type="btn" routerLink="/vendor/manage-rfp/live" class="backButton">
                            <i class="fa-solid fa-arrow-left"></i>&nbsp;<span>Back</span>
                        </button>
                    </div> -->

                    <div class="form_set">
                        <form name="contactDetailsForm" (ngSubmit)="(contactDetailsForm.valid)"
                            #contactDetailsForm="ngForm" novalidate>

                            <!-- ===== TOP HEADER ===== -->
                            <div class="row m-0 align-items-center">
                                <div class="col-md-12">
                                    <div class="d-flex align-items-center ps-0 flex-wrap">
                                        <h2 class="page_heading">{{ liveRfpData.rfpCode }}</h2>
                                        <button type="button" class="button-box" [ngStyle]="{
                                        color: getStatusColor(liveRfpData.rfpStatus),
                                        'font-size': '15px'
                                      }">
                                            {{ liveRfpData.rfpStatus }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- ===== TWO-COLUMN LAYOUT ===== -->
                            <div class="row g-4 mt-2">
                                <!-- LEFT: RFP Details -->
                                <div class="col-lg-7 col-md-12">
                                    <div class="outer-borders">
                                        <div class="row g-3">
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">RFP Type : <span>{{ liveRfpData.rfpCategory
                                                        }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">RFP Name : <span>{{ liveRfpData.rfpTypeFor
                                                        }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">RFP code : <span>{{ liveRfpData.rfpCode }}</span>
                                                </p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">Start date : <span>{{ liveRfpData.rfpStartDate |
                                                        date:"dd-MM-yyyy" }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">Start time : <span>{{ liveRfpData.rfpStartTime
                                                        }}{{ startTime }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">End Date : <span>{{ liveRfpData.rfpEndDate |
                                                        date:"dd-MM-yyyy" }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">End Time : <span>{{ liveRfpData.rfpEndTime }}{{
                                                        endTime }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">Commercial Weightage : <span>{{
                                                        liveRfpData.rfpCommercialWeightage }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">Technical Weightage : <span>{{
                                                        liveRfpData.rfpTechnicalWeightage }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">Billing Address : <span>{{
                                                        liveRfpData.locationText }}</span></p>
                                            </div>
                                            <div class="col-lg-4 col-6">
                                                <p class="text-p-type">RFP Document : <span></span></p>
                                            </div>
                                            <div class="col-lg-4 col-6" *ngFor="let doc of Document">
                                                <a [href]="doc?.rfp_FileUpload" download>
                                                    <i class="fa-solid fa-eye fa-xl"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- RIGHT: Timer + Not Interested -->
                                <!-- In the timer section -->
                                <div class="col-lg-5 col-md-12">
                                    <div class="card-body p-0">
                                        <div class="count-down-timer">
                                            <div class="wrapper" *ngIf="liveRfpData.rfpEndDate; else noEndDate">
                                                <div class="description">
                                                    <p>Days</p>
                                                    <p>Hours</p>
                                                    <p>Minutes</p>
                                                    <p>Seconds</p>
                                                </div>
                                                <div class="times">
                                                    <p class="time" #days></p>
                                                    <p class="time" #hours></p>
                                                    <p class="time" #minutes></p>
                                                    <p class="time" #seconds></p>
                                                </div>
                                            </div>
                                            <ng-template #noEndDate>
                                                <div class="alert alert-warning">
                                                    <p>End date not set for this RFP</p>
                                                </div>
                                            </ng-template>
                                            <div class="mx-auto d-flex">
                                                <button type="button" class="boxSecond"
                                                    (click)="vendorStatus('notInterested')">
                                                    1 Not Interested
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- ===== LEAD TIME, CREDIT DAYS, RFP REMARK ===== -->
                            <fieldset>
                                <div class="businessDetailPage justify-content-between mb-3 mt-4">
                                    <div class="row g-3">
                                        <div class="col-md-4">
                                            <label for="lead_time" class="form-label mandatory">Lead Time</label>
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="lead_time" id="lead_time"
                                                    [(ngModel)]="contact.lead_time" #lead_time="ngModel" required
                                                    [ngClass]="{
                                                  'is-invalid': (lead_time.touched || contactDetailsForm.submitted) && lead_time.errors
                                                }" />
                                                <div *ngIf="(lead_time.touched || contactDetailsForm.submitted) && lead_time.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="lead_time.errors?.['required']">Lead Time is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="credit_days" class="form-label mandatory">Credit
                                                    Days</label>
                                                <input type="text" class="form-control" name="credit_days"
                                                    #credit_days="ngModel" [ngClass]="{
                                              'is-invalid': (credit_days.touched || contactDetailsForm.submitted) && credit_days.errors
                                            }" [(ngModel)]="contact.credit_days" id="credit_days" required />
                                                <div *ngIf="(credit_days.touched || contactDetailsForm.submitted) && credit_days.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="credit_days.errors?.['required']">Credit days is
                                                        required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-7">
                                            <div class="form-group">
                                                <label for="remark" class="form-label mandatory">RFP Remark</label>
                                                <textarea class="form-control" disabled
                                                    rows="3">{{ liveRfpData.remark }}</textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ===== ITEM / SERVICE / BOM TABLE ===== -->
                                <div class="table-responsive" *ngIf="rfpCategory === 'ItemRFP'">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Product Name</th>
                                                <th>Quantity</th>
                                                <th>Price Per Item</th>
                                                <th *ngFor="let header of productheader">{{ header.priceParameterName }}
                                                </th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of vendorEmployees; let i = index">
                                                <td>{{ i + 1 }}</td>
                                                <td>{{ item.itemName }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td>
                                                    <input type="number" class="form-control"
                                                        [(ngModel)]="item.pricePerItem"
                                                        name="{{ item.itemName }}{{ i }}"
                                                        (ngModelChange)="calculateItemSum(item)" />
                                                </td>
                                                <td *ngFor="let header of productheader">
                                                    <input type="number" class="form-control"
                                                        name="{{ header.priceParameterName }}{{ i }}"
                                                        [(ngModel)]="item[header.priceParameterName]"
                                                        (ngModelChange)="calculateItemSum(item)" [disabled]="
                                            (header.priceParameterName === 'IGST' && (item.CGST || item.SGST)) ||
                                            ((header.priceParameterName === 'CGST' || header.priceParameterName === 'SGST') && item.IGST)
                                          " />
                                                </td>
                                                <td>
                                                    <input type="number" disabled class="form-control"
                                                        [(ngModel)]="item.itemAmount"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [value]="item.calculatedSum ? item.calculatedSum : 0"
                                                        (change)="calculateItemTotal()" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="table-responsive" *ngIf="rfpCategory === 'ServiceRFP'">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Service Name</th>
                                                <th>Frequency</th>
                                                <th>No. of Frequency</th>
                                                <th>Price Per Item</th>
                                                <th *ngFor="let header of productheader">{{ header.priceParameterName }}
                                                </th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of vendorEmployees; let i = index">
                                                <td>{{ i + 1 }}</td>
                                                <td>{{ item.itemName }}</td>
                                                <td>{{ item.frequency }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td>
                                                    <input type="number" class="form-control"
                                                        [(ngModel)]="item.pricePerItem"
                                                        name="{{ item.itemName }}{{ i }}"
                                                        (ngModelChange)="calculateItemSum(item)" />
                                                </td>
                                                <td *ngFor="let header of productheader">
                                                    <input type="number" class="form-control"
                                                        name="{{ header.priceParameterName }}{{ i }}"
                                                        [(ngModel)]="item[header.priceParameterName]"
                                                        (ngModelChange)="calculateItemSum(item)" [disabled]="
                                            (header.priceParameterName === 'IGST' && (item.CGST || item.SGST)) ||
                                            ((header.priceParameterName === 'CGST' || header.priceParameterName === 'SGST') && item.IGST)
                                          " />
                                                </td>
                                                <td>
                                                    <input type="number" disabled class="form-control"
                                                        [(ngModel)]="item.itemAmount"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [value]="item.calculatedSum ? item.calculatedSum : 0"
                                                        (change)="calculateItemTotal()" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="table-responsive" *ngIf="rfpCategory === 'BomRFP'">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Product Name</th>
                                                <th>Quantity</th>
                                                <th>Price Per Item</th>
                                                <th *ngFor="let header of productheader">{{ header.priceParameterName }}
                                                </th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of vendorEmployees; let i = index">
                                                <td>{{ i + 1 }}</td>
                                                <td>{{ item.itemName }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td>
                                                    <input type="number" class="form-control"
                                                        [(ngModel)]="item.pricePerItem"
                                                        name="{{ item.itemName }}{{ i }}"
                                                        (ngModelChange)="calculateItemSum(item)" />
                                                </td>
                                                <td *ngFor="let header of productheader">
                                                    <input type="number" class="form-control"
                                                        name="{{ header.priceParameterName }}{{ i }}"
                                                        [(ngModel)]="item[header.priceParameterName]"
                                                        (ngModelChange)="calculateItemSum(item)" [disabled]="
                                            (header.priceParameterName === 'IGST' && (item.CGST || item.SGST)) ||
                                            ((header.priceParameterName === 'CGST' || header.priceParameterName === 'SGST') && item.IGST)
                                          " />
                                                </td>
                                                <td>
                                                    <input type="number" disabled class="form-control"
                                                        [(ngModel)]="item.itemAmount"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [value]="item.calculatedSum ? item.calculatedSum : 0"
                                                        (change)="calculateItemTotal()" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- ===== TOTAL CHARGES ===== -->
                                <div class="row businessDetailPage mt-3" style="justify-content: right;">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="total_charges" class="form-label mandatory">Total
                                                Charges</label>
                                            <div class="input-group textIcons">
                                                <span class="iconText">{{ liveRfpData?.currency_code | currencySymbol
                                                    }}</span>
                                                <input type="number" style="margin-top:10px" [(ngModel)]="total_Charges"
                                                    [ngModelOptions]="{ standalone: true }" disabled
                                                    class="form-control" name="total_charges" id="total_charges"
                                                    [value]="calculateItemTotal()" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ===== TECHNICAL RFP ===== -->
                                <div class="row mt-4">
                                    <div class="form-group">
                                        <h4 class="page_heading mb-3">Technical RFP</h4>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>S. No.</th>
                                                        <th>Question</th>
                                                        <th>Answer</th>
                                                        <th>Document</th>
                                                        <th>Remarks</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let questioner_map of contact.vendorQuestionAnswer; let i = index">
                                                        <td>{{ i + 1 }}</td>
                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" class="form-control"
                                                                    name="question{{ i }}" readonly
                                                                    [(ngModel)]="questioner_map.question" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group"
                                                                *ngIf="questioner_map.questionType == 'Objective'">
                                                                <select class="form-select" name="answer{{ i }}"
                                                                    [(ngModel)]="questioner_map.answer">
                                                                    <option [value]="null" [selected]="true" disabled>
                                                                        Select Value</option>
                                                                    <option value="YES">YES</option>
                                                                    <option value="NO">NO</option>
                                                                </select>
                                                            </div>
                                                            <div class="form-group"
                                                                *ngIf="questioner_map.questionType == 'Subjective'">
                                                                <textarea class="form-control" id="question"
                                                                    name="technicalQuestion{{ i }}" placeholder="answer"
                                                                    [(ngModel)]="questioner_map.answer"></textarea>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="col-md-4">
                                                                <div class="fileData circle-box"
                                                                    [class.mandatory]="questioner_map.mandatory"
                                                                    style="width:16rem">
                                                                    <input type="file" class="form-control m-0"
                                                                        id="vendorBiddingFiles{{ i }}" accept=""
                                                                        name="vendorBiddingFiles{{ i }}"
                                                                        (change)="onFileChange1($event, i)" />
                                                                    <div *ngIf="questioner_map.document != null"
                                                                        class="pdf-preview">
                                                                        <a [href]="questioner_map?.document" download>
                                                                            <i class="fa-solid fa-eye fa-xl"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" class="form-control"
                                                                    name="remark{{ i }}" placeholder="remark"
                                                                    [(ngModel)]="questioner_map.remark" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <!-- ===== REMARK & UPLOAD ===== -->
                                <div class="row businessDetailPage mt-3">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="remark" class="form-label mandatory">Remark</label>
                                            <textarea type="text" class="form-control" name="remark" id="remark"
                                                rows="4" #remark="ngModel" [(ngModel)]="contact.remark" [ngClass]="{
                              'is-invalid': (remark.touched || contactDetailsForm.submitted) && remark.errors
                            }" style="overflow:hidden" required></textarea>
                                            <div *ngIf="(remark.touched || contactDetailsForm.submitted) && remark.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="remark.errors?.['required']">Remark is required.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 mt-4">
                                        <div class="form-group">
                                            <label for="rfpUploadedFile" class="col-form-label">Upload Document</label>
                                            <ng-container>
                                                <div class="fileData circle-box">
                                                    <input type="file" class="form-control m-0" id="vendorBiddingFiles"
                                                        name="vendorBiddingFiles" (change)="onFileChange($event)" />
                                                    <div *ngIf="item?.document != null" class="pdf-preview">
                                                        <a [href]="item?.document" download>
                                                            <i class="fa-solid fa-eye fa-xl"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>

                        <!-- ===== SUBMIT BUTTON ===== -->
                        <div class="d-flex justify-content-end backNextButton mt-3">
                            <button class="sumbitButton btn-primary-submit" type="submit" (click)="submit()">
                                <i class="fa-solid fa-floppy-disk me-2"></i><span>Submit & Next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>